import React, {useContext, useState, useEffect} from "react";
import {Button} from "antd";
import {UserContext} from "@context/UserContext";


const ListItemTestResultStudent = props => {
    const {testResult, onClick, onClickDiagnosticTest} = props;
    const {user} = useContext(UserContext);
    const [viewResults, setViewResults] = useState(false),
        [viewResultsDiagnostic, setViewResultsDiagnostic] = useState(false);

    useEffect(() => {
        // console.log('testResult: ',testResult);
        if ((testResult.expired || testResult.revision || testResult.noExpiry) && !testResult.diagnosticTest) {
            setViewResults(true);
        }else if(testResult.diagnosticTest){
            setViewResultsDiagnostic(true);
        }
    }, []);

    return (
        <tr>
            <td>
                {viewResults &&
                    <Button type="link" className={'ch-link'} tabIndex={0} onClick={onClick}>{testResult.testName}</Button>
                }
                {viewResultsDiagnostic &&
                    <Button type="link" className={'ch-link'} tabIndex={0} onClick={onClickDiagnosticTest}>{testResult.testName}</Button>
                }
                {(!viewResults && !viewResultsDiagnostic) &&
                    testResult.testName
                }
            </td>
            <td className={'ch-table-noWrap'}>
                {user.dateTimeFormat.format(testResult.assignedDate)}
            </td>
            <td className={'ch-table-noWrap'}>
                {testResult.testAssignmentStatusDescription}
            </td>
            <td className={'ch-table-noWrap'}>
                {testResult.showResult ? testResult.mark+'/'+testResult.maxMark : 'N/A'}
            </td>
            <td className={'ch-table-noWrap'}>
                {testResult.exam ? 'Exam' : testResult.diagnosticTest ? 'Diagnostic' : 'Test'}
            </td>
        </tr>
    )
}

export default ListItemTestResultStudent;